export default __webpack_public_path__ + "static/media/cif-cl.01201c28.svg";